// EN translations for the v2 pages: impostazioni.js, support.js, pec.js
// gettext pattern: the Italian string is the key. Placeholders {x} are preserved.
const m = {
  // ── impostazioni.js ──
  'Home': 'Home',
  'Parametri': 'Settings',
  'La tua organizzazione': 'Your organization',
  'Modificare': 'Edit',
  'Indirizzo': 'Address',
  'Telefono': 'Phone',
  'Condizioni generali': 'General terms',
  'Contratti speciali': 'Special contracts',
  "Elimina l'organizzazione": 'Delete the organization',
  'Personalizzazione': 'Personalization',
  'Logo del manager': 'Manager logo',
  'Logo delle applicazioni': 'Applications logo',
  'Per più informazioni': 'Learn more',
  'Prodotti': 'Products',
  'Utenti': 'Users',
  'Gestire': 'Manage',
  'Etichetta': 'Label',
  "Personalizza l'aspetto del tuo Manager: logo, colori e branding visibili a te e ai tuoi utenti.": 'Customize the look of your Manager: logo, colors and branding visible to you and your users.',
  'Logo': 'Logo',
  "Mostrato nell'intestazione del tuo Manager.": 'Shown in your Manager header.',
  'Mostrato nelle applicazioni collegate al tuo account.': 'Shown in the applications linked to your account.',
  'Carica': 'Upload',
  'Custom Brand — personalizza colori e dominio': 'Custom Brand — customize colors and domain',
  'Gestione dei prodotti': 'Product management',
  'Gestisci i tuoi prodotti': 'Manage your products',
  'Gestisci, trasferisci o disattiva i prodotti della tua organizzazione.': 'Manage, transfer or deactivate your organization products.',
  'Prodotto': 'Product',
  'Trasferisci i prodotti': 'Transfer products',
  'Caricamento…': 'Loading…',
  'Nessun prodotto': 'No products',
  'Nome': 'Name',
  'Scadenza': 'Expiry',
  'Tag': 'Tag',
  'Scade il {data}': 'Expires on {data}',
  'Rinnovo automatico': 'Automatic renewal',
  'Sicurezza': 'Security',
  "Attiva delle opzioni di sicurezza aggiuntive per tutti gli utenti dell'organizzazione:": 'Enable additional security options for all users in the organization:',
  'Verifica in due passaggi obbligatoria (2FA)': 'Mandatory two-step verification (2FA)',
  'Consigliato': 'Recommended',
  "Richiedi una verifica aggiuntiva dell'accesso a tutti gli utenti dell'organizzazione per rafforzare la sicurezza.": 'Require additional login verification for all users in the organization to strengthen security.',
  'Blocco del recupero della password tramite SMS': 'Block password recovery via SMS',
  'Impedisci agli utenti della tua organizzazione di utilizzare il metodo SMS per recuperare la password.': 'Prevent users in your organization from using the SMS method to recover their password.',
  'Attivato': 'Enabled',
  'Disattivato': 'Disabled',
  'Etichette': 'Labels',
  'Crea etichette per organizzare e filtrare i tuoi prodotti.': 'Create labels to organize and filter your products.',
  'Nessuna etichetta': 'No labels',
  "Crea un'etichetta": 'Create a label',
  'Certificati legali': 'Legal certificates',
  'Consulta e scarica i certificati legali e i documenti RGPD della tua organizzazione.': 'View and download your organization legal certificates and GDPR documents.',
  'Nessun certificato disponibile': 'No certificate available',
  'Consulta le condizioni generali di vendita e di utilizzo dei servizi NeoFlux.': 'View the general terms of sale and use of NeoFlux services.',
  'Nessun documento accettato': 'No document accepted',
  'Documenti e Contratti speciali': 'Documents & special contracts',
  'Gestisci i contratti speciali e i documenti dedicati alla tua organizzazione.': 'Manage the special contracts and documents dedicated to your organization.',
  'Nessun contratto speciale': 'No special contract',

  // ── support.js ──
  'Chiudi': 'Close',
  'Supporto': 'Support',
  'Consulta le FAQ': 'Check the FAQ',
  'Servizio di assistenza Premium': 'Premium support service',
  'Per saperne di più sulle nostre offerte di supporto per organizzazioni e sviluppatori.': 'Learn more about our support offerings for organizations and developers.',
  '7gg/7': '7 days/7',
  'Risposta prioritaria': 'Priority response',
  'Chiamate urgenti 24/7': 'Urgent calls 24/7',
  'Consulenze personalizzate': 'Personalized consulting',
  'Scopri il Servizio di assistenza Premium': 'Discover the Premium support service',
  'Contatta i nostri team tramite chat, e-mail o telefono': 'Contact our teams via chat, email or phone',
  'Bisogno di aiuto? Siamo a tua completa disposizione.': 'Need help? We are entirely at your disposal.',
  "Contattare l'assistenza": 'Contact support',
  'Centrale chiusa': 'Support center closed',
  '7 g./7': '7 d./7',
  'da 06h00 a 23h00': 'from 06:00 to 23:00',
  'Tempi di risposta rapidi': 'Fast response times',
  'Le mie richieste': 'My requests',
  'Chiamata': 'Call',
  '5 g./7': '5 d./7',
  'da 09:00 a 18:00': 'from 09:00 to 18:00',
  'Accessi rapidi': 'Quick access',
  'Codice di autorizzazione': 'Authorization code',
  "Concedi l'accesso al servizio di assistenza": 'Grant access to the support service',
  'Scegli il canale più adatto: ti risponderemo il prima possibile.': 'Choose the most suitable channel: we will reply as soon as possible.',
  'Chatta in tempo reale con un operatore': 'Chat in real time with an operator',
  'Crea un ticket': 'Create a ticket',
  'Apri una richiesta via e-mail': 'Open a request via email',
  'Chiamaci': 'Call us',
  'Dal lunedì al venerdì, 09:00–18:00': 'Monday to Friday, 09:00–18:00',
  '{n} richiesta/e': '{n} request(s)',
  'Nessuna richiesta': 'No requests',
  'Crea una richiesta': 'Create a request',

  // ── pec.js ──
  'Posta Certificata': 'Certified email (PEC)',
  'Firma Digitale': 'Digital signature',
  'Fatturazione Elettronica': 'Electronic invoicing',
  'Marca Temporale': 'Timestamp',
  'Attiva': 'Active',
  'In attesa': 'Pending',
  'Non hai nessuna casella PEC': 'You have no PEC mailbox',
  'Attiva una casella di Posta Elettronica Certificata con valore legale per le tue comunicazioni ufficiali.': 'Activate a legally valid Certified Email (PEC) mailbox for your official communications.',
  'Attiva una PEC': 'Activate a PEC',
  'Scopri le nostre offerte': 'Discover our offers',
  'Casella PEC': 'PEC mailbox',
  'Caselle PEC': 'PEC mailboxes',
  'Indirizzo PEC': 'PEC address',
  'Dominio': 'Domain',
  'Piano': 'Plan',
  'Stato': 'Status',
  'Non hai nessuna identità SPID': 'You have no SPID identity',
  'Richiedi la tua identità digitale SPID per accedere ai servizi della Pubblica Amministrazione e dei privati.': 'Request your SPID digital identity to access public administration and private services.',
  'Richiedi lo SPID': 'Request SPID',
  'Scopri di più': 'Find out more',
  'Non hai nessuna firma digitale': 'You have no digital signature',
  'Firma documenti con valore legale grazie alla firma elettronica qualificata eIDAS, valida in tutta Europa.': 'Sign legally valid documents with the eIDAS qualified electronic signature, valid throughout Europe.',
  'Attiva la Firma Digitale': 'Activate the Digital Signature',
  'Nessun servizio di fatturazione elettronica': 'No electronic invoicing service',
  "Gestisci l'invio e la conservazione delle fatture elettroniche verso PA e privati (SDI).": 'Manage the sending and storage of electronic invoices to public administration and private entities (SDI).',
  'Attiva la Fatturazione': 'Activate Invoicing',
  'Nessuna marca temporale': 'No timestamp',
  "Certifica la data e l'ora di un documento con valore legale grazie alla marcatura temporale.": 'Certify the legally valid date and time of a document with timestamping.',
  'Acquista Marche Temporali': 'Buy Timestamps',
};
export default m;
